module.exports = __webpack_public_path__ + "media/images/application/template/icon--modular-tool-orange-c69b549526cbadd156b9be0b436795b0.svg";